import React, { Dispatch, SetStateAction } from "react";

import Dropzone from "react-dropzone";

import { DropContainer, UploadMessage, Container } from "./styles";

interface IProps {
  file: File | null;
  setFile: Dispatch<SetStateAction<File | null>>;
  disabled?: boolean;
  maxFiles?: number;
  typeFile?: string;
  maxSize?: number;
  isProfileImage?: boolean;
}

const Upload: React.FC<IProps> = ({
  file,
  setFile,
  disabled,
  maxFiles,
  typeFile,
  maxSize,
  isProfileImage = false,
}) => {
  const renderDragMessage = (isDragActive, isDragReject) => {
    if (isProfileImage) {
      return <UploadMessage>Alterar foto</UploadMessage>;
    }

    if (!isDragActive) {
      return (
        <UploadMessage>
          Clique ou arraste para adicionar o arquivo
          <strong>{file?.name}</strong>
        </UploadMessage>
      );
    }

    if (isDragReject) {
      return (
        <UploadMessage typeof="error">Arquivo não suportado!</UploadMessage>
      );
    }

    return (
      <UploadMessage typeof="success">Adicione o arquivo aqui!</UploadMessage>
    );
  };

  return (
    <Container>
      <Dropzone
        disabled={disabled}
        accept={typeFile}
        onDropAccepted={(files) => setFile(files[0])}
        maxFiles={maxFiles || 1}
        maxSize={maxSize}
      >
        {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
          <DropContainer
            {...getRootProps()}
            dragActive={isDragActive}
            dragReject={isDragReject}
          >
            <input {...getInputProps()} />

            {renderDragMessage(isDragActive, isDragReject)}
          </DropContainer>
        )}
      </Dropzone>
    </Container>
  );
};

export default Upload;
